export const UnassignedPickupsComponentName: string = 'unassignedPickups';
